import styled from 'styled-components';
import {SIZES, Typography} from '@fupa/fupa-uikit';

export const LastItemsWrapper = styled.div`
  padding: ${SIZES[16]} ${SIZES[16]} 0;
  height: 125px;
`;

export const LastItems = styled.div`
  padding-top: ${SIZES[8]};
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  gap: ${SIZES[4]};
  height: ${SIZES[88]};
  max-width: 552px;
  overflow-x: scroll;
`;

export const StyledTypography = styled(Typography)`
  line-height: ${SIZES[20]};
`;
